
import { Component, toNative, Vue } from 'vue-facing-decorator';

@Component({
  components: {
  },
})
class Home extends Vue {}
export default toNative(Home);
